import _fragmentPageIndustryDetailTemplate from './_fragment-page-industry-detail-template'

const pageContentType = 'PageIndustryFoodBeveragePayments'

export default _fragmentPageIndustryDetailTemplate(pageContentType)
